/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { UserApprovalSettingsModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class CompanyAdminSettingsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags CompanyAdminSettings
   * @name CompanyAdminSettingsGet
   * @summary Gets The Company Admin Settings.
   * @request GET:/companyAdminSettings
   */
  companyAdminSettingsGet = (params: RequestParams = {}) =>
    this.http.request<UserApprovalSettingsModelDto[], any>({
      path: `/companyAdminSettings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CompanyAdminSettings
   * @name CompanyAdminSettingsApprovalSettings
   * @summary Updates the Approval Settings with the specified information.
   * @request PUT:/companyAdminSettings/{id}
   */
  companyAdminSettingsApprovalSettings = (
    id: number,
    data: UserApprovalSettingsModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<UserApprovalSettingsModelDto[], any>({
      path: `/companyAdminSettings/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
